import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { grey } from '@mui/material/colors'; // Import grey color palette

const TopBarFieldSettings = ({ onDone, onNavigateBack, barHeight = '50px', fontSize = '0.8rem' }) => {
  const [isCommitting, setIsCommitting] = React.useState(false);

  const handleDoneClick = async () => {
    if (isCommitting) return;

    setIsCommitting(true);

    try {
      if (typeof onDone === 'function') {
        await Promise.resolve(onDone());
      }

      if (typeof onNavigateBack === 'function') {
        onNavigateBack();
      }
    } catch (error) {
      console.error('[TopBarFieldSettings] Failed to commit field changes:', error);
    } finally {
      setIsCommitting(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: barHeight,
        backgroundColor: 'rgba(213, 228, 249, 0.5)',
        padding: '10px',
        borderBottom: `1px solid ${grey[300]}`, // Apply a grey border at the bottom
      }}
    >
      <IconButton
        onClick={handleDoneClick} // Use handleDoneClick to wrap additional logging or functionality
        disabled={isCommitting}
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontSize, // Ensure font size is applied correctly
          color: '#003459', // Set the color directly on the button for consistency
          '&:hover': { // Apply hover effects specifically to the text
            backgroundColor: 'transparent', // Make background transparent on hover
            '& .MuiTypography-root': { // Target the Typography component only
              textDecoration: 'underline' // Only underline on hover
            }
          }
        }}
      >
        <NavigateBeforeIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> {/* Reduced icon size */}
        <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize }}> {/* Smaller text */}
          Done
        </Typography>
      </IconButton>
    </Box>
  );
};

export default TopBarFieldSettings;
